// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__Roh61","icon":"Alert_icon__8k8X8"};